export default __webpack_public_path__ + "d03b4549d2ad760116a90d9c165455ba.svg";